/**
 * @module components/ZonesAdvisory
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Request summary table
 */
import { Alert } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';


type Props = {
  zones: String[],
}


/**
 * React component
 * ===============
 */
const ZonesAdvisory = ({
  zones,
}: Props) => {
  const [ lang ] = useLanguageState();

  let content = '';
  // no zones, we are outside Canada
  if(zones.length === 0) {
    if( lang.abbr === 'fr' ){
      content = 'Désolé, l\'emplacement se situe à l\'extérieur du Canada et de ses régions voisines. Vérifiez si vous avez correctement saisi vos coordonnées (la longitude devrait être négative pour le Canada). Veuillez consulter le site Web de la Commission géologique des États-Unis (United States Geological Survey) sur les aléas sismiques afin d\'obtenir des données sur le territoire des États-Unis.';
    } else {
      content = 'Sorry, the point is outside Canada and nearby regions. Please ensure you have entered your coordinates correctly (longitude should be negative for Canada). Please refer to the United States Geological Survey\'s seismic hazard site for definitive US values.';
    }
  }
  else if(zones.find((ele) => ele === 'NBC_CNB2020_High-Arctic-Warning_Haut-Arctique-Avis')) {
    if( lang.abbr === 'fr' ){
      content = 'Dans le Haut-Arctique, les contributions aux aléas sismiques provenant de sources extérieures au territoire canadien n\'ont pas été prises en compte. Veuillez consulter le commentaire intitulé Calcul fondé sur les effets dus aux séismes du "Commentaires sur le calcul des structures (Guide de l\'utilisateur - CNB 2020 : Partie 4 de la division B)" pour obtenir des conseils pertinents.';  
    } else {
      content = 'In the high Arctic, seismic hazard contributions from sources outside Canadian territory have not been considered. Please refer to the commentary entitled Design for Seismic Effects in the “Structural Commentaries (User\'s Guide - NBC 2020: Part 4 of Division B)” for relevant guidance.';  
    }
  }
  else if(zones.find((ele) => ele === 'NBC_CNB2020_NW-Fault-Warning_NO-Faille-Avis_1' || ele === 'NBC_CNB2020_NW-Fault-Warning_NO-Faille-Avis_2')) {
    if( lang.abbr === 'fr' ){
      content = 'Vous êtes à proximité des failles côtières modélisées du nord-ouest de la Colombie-Britannique et de l\'ouest du Yukon. Les gradients d\'aléas sont très abrupts dans cette région. Veuillez consulter le commentaire intitulé Calcul fondé sur les effets dus aux séismes du "Commentaires sur le calcul des structures (Guide de l\'utilisateur - CNB 2020 : Partie 4 de la division B)" pour obtenir des conseils pertinents.';  
    } else {
      content = 'You are in close proximity to modelled onshore fault(s) in northwestern British Columbia and western Yukon. Hazard gradients are very steep in this region. Please refer to the commentary entitled Design for Seismic Effects in the “Structural Commentaries (User\'s Guide - NBC 2020: Part 4 of Division B)” for relevant guidance.';
    }
  }

  if(content.length === 0)
    return null;

  return (
    <Alert bsStyle='warning'>
      <p>{content}</p>
    </Alert>
  )
};

export default ZonesAdvisory;